export enum ApplicationStatus {
    COMPLETE,
    PAID,
    DENIED,
    DENIED_WITH_OFFER,
    COMPLETE_WITH_OFFER,
    INCOMPLETE
}